import Model from "@tripian/model";
import moment from "moment";
import React from "react";
import TripianLogo from "../../../assets/img/Tripian_Logo.png";
// import visa from "../img/visa.png";

type Props = {
  theme?: "dark" | "light";
  t: (value: Model.TranslationKey) => string;
};

const Footer: React.FC<Props> = ({ theme = "light", t }) => {
  return (
    <footer className="pt-20 pb-12 px-16 bg-neutral-100 rounded-t-[5rem] flex flex-col gap-16">
      <div className="w-full flex flex-col gap-12 md:flex-row justify-between items-start md:items-center">
        <img
          src={
            theme === "dark"
              ? window.tconfig.IMAGE_PATHS.LOGO_PATH_DARK
              : window.tconfig.IMAGE_PATHS.LOGO_PATH_LIGHT || TripianLogo
          }
          alt="Provider Logo"
          className="max-h-16 max-w-40 w-auto h-auto"
        />
        <div className="flex flex-col gap-8 md:flex-row md:space-x-6 rtl:space-x-reverse text-sm text-gray-600">
          <a
            href="https://www.tripian.com/about-us"
            target="_blank"
            className="text-neutral-900 hover:text-neutral-700 font-semibold text-lg"
            rel="noreferrer"
          >
            {t("landing.about")}
          </a>
          <a
            href="https://tripian.com/terms-conditions"
            target="_blank"
            className="text-neutral-900 hover:text-neutral-700 font-semibold text-lg"
            rel="noreferrer"
          >
            {t("landing.termsOfUse")}
          </a>
          <a
            href="https://tripian.com/privacy-policy"
            target="_blank"
            className="text-neutral-900 hover:text-neutral-700 font-semibold text-lg"
            rel="noreferrer"
          >
            {t("landing.privacyPolicy")}
          </a>
        </div>
      </div>

      <div className="w-full hidden md:flex flex-col md:flex-row justify-between items-center">
        <div className="text-neutral-400 text-base font-medium">
          © {moment().format("YYYY")} {t("landing.allRightsReserved")}
        </div>
        {window.tconfig.BRAND_NAME !== "Tripian" && (
          <div className="flex items-center space-x-2 rtl:space-x-reverse">
            <div className="text-neutral-400 text-xs font-bold">
              {t("landing.poweredBy")}
            </div>
            <img
              className="max-w-24 h-8 mt-1"
              src={TripianLogo}
              alt="tripian"
            />
          </div>
        )}
      </div>

      <div className="w-full md:hidden flex flex-col md:flex-row justify-between items-start gap-12">
        {window.tconfig.BRAND_NAME !== "Tripian" && (
          <div className="flex flex-col gap-2">
            <div className="text-neutral-400 text-xs font-bold">
              {t("landing.poweredBy")}
            </div>
            <img
              className="max-w-24 h-auto -ms-1"
              src={TripianLogo}
              alt="tripian"
            />
          </div>
        )}
        <div className="text-neutral-400 text-base font-medium">
          © {moment().format("YYYY")} {t("landing.allRightsReserved")}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
